<template>
  <div class="d-flex">
    <template v-for="(card, index) in cards(props.pokerCombination)">
      <div class="poker-card" :class="card.suit">
        <span v-if="card.suit !== 'sheet'" class="symbol">{{card.symbol}}</span>
        <img v-if="card.suit !== 'sheet'" class="suit" :src="`/img/pokercards/${card.suit}.svg`">
        <img v-else  src="/img/pokercards/sheet.png">
        <div v-if="card.suit === 'sheet'" class="fog" :style="{height: index === fogIndex ? fogHeight : '100%'}"></div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import TournamentParticipantPokerCombinationDTO from "@/models/TournamentParticipantPokerCombinationDTO";
import {computed} from "vue";

const props = defineProps<{
  pokerCombination: TournamentParticipantPokerCombinationDTO|null
}>()

interface Card {
  symbol: string
  suit: string
}

const SYMBOL_MAP = {1: 'A', 11: 'J', 12: 'Q', 13: 'K'} as any;
const SUITS_MAP = {'C': 'clubs', 'H': 'hearts', 'D': 'diamonds', 'S': 'spades'} as any;

const cards = (pokerCombination: TournamentParticipantPokerCombinationDTO|null): Card[] => {
  const openCards = pokerCombination?.openCards ?? [];
  let cards = [] as Card[];
  for (const card of openCards) {
    const parts = card.split(':');
    const symbolIndex = parts[0];
    const suitIndex = parts[1];

    cards.push({
      symbol: SYMBOL_MAP[symbolIndex] ?? symbolIndex,
      suit: SUITS_MAP[suitIndex]
    } as Card)
  }

  for (let i = cards.length; i < 5; i++) {
    cards.push({
      symbol: '',
      suit: 'sheet'
    } as Card)
  }

  return cards;
}

const fogHeight = computed(() => {
  if (!props.pokerCombination) {
    return '100%';
  }

  const percent = 100 - parseFloat(props.pokerCombination.currentCardProgress) * 100
  return percent + '%';
})

const fogIndex = computed(() => {
  if (!props.pokerCombination) {
    return -1;
  }

  return props.pokerCombination.openCards.length;
})

</script>